import { createFileRoute, Navigate } from "@tanstack/react-router";
import { useAuth } from "@clerk/clerk-react";

export const Route = createFileRoute("/")({
  component: IndexPage,
});

function IndexPage() {
  const { isSignedIn } = useAuth();

  if (isSignedIn) {
    return <Navigate to="/app/search" />;
  }

  return <Navigate to="/login" />;
}
